import { render, staticRenderFns } from "./pageBanner2.vue?vue&type=template&id=5c64e4cf"
import script from "./pageBanner2.vue?vue&type=script&lang=js"
export * from "./pageBanner2.vue?vue&type=script&lang=js"
import style0 from "./pageBanner2.vue?vue&type=style&index=0&id=5c64e4cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports